const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'base',
        'tableSimple',
        'filter',
    ],

    config: {
        resourceConnected: false,
        isFullyVertical: true,
        tableComponentClass: 'templates_core_table_table',
        controllerComponentClass: 'templates_core_controller_controller'
    },

    methods: {

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const key = message.heartbeatKey

            if(this.$ && this.$.is(':visible')){
                // TODO: handle multiple heartbeats
                this.model.triggerHeartbeat = {message, heartbeatPrewarmedResourceHashes}
            } else {
                // check if there are any fields which have to be refreshed on their own.
                // NOTE: if the full form is refreshed the fields will check themselves if it is necessary to reload their resources.
                for(const field of this.model.fields || []){
                    const fieldRefreshes = (field.config || {}).heartbeatRefreshOn || {}
                    if(fieldRefreshes[key] && field.fieldCode){
                        const $field = this.$.find(`[data-field-code="${field.fieldCode}"]`)
                        const fieldComponent = getComponent($field, true)
                        if(fieldComponent){
                            fieldComponent.refresh(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
                        }
                    }
                }
            }
        }
    },

    hooks: {
        resetFilters($element, options){
            this.resetDirties()
            const {filters} = options || {}
            if(utils.collectionSize(filters) > 0){
                for(const fieldCode in filters){
                    this.fieldToModel(fieldCode, filters[fieldCode])
                }

                this.refresh()
            }
        },
    },

    handlers: [
        {
            name: 'onTabDeactivate',
            handle(callerComponent){
                const triggerHeartbeat = this.model.triggerHeartbeat
                if(triggerHeartbeat && this.$ && !this.$.is(':visible')){
                    delete this.model.triggerHeartbeat
                    this.onHeartbeat(triggerHeartbeat.message, triggerHeartbeat.heartbeatPrewarmedResourceHashes)
                }
            }
        },
    ]
}